import script from "./BigPicturesOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./BigPicturesOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./BigPicturesOverlay.vue?vue&type=style&index=0&id=634e7a42&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634e7a42"]])

export default __exports__